import { PREFIX } from "./base";

export const WORD_CLOUD_ANGLE = `${PREFIX}_WORD_CLOUD_ANGLE`;

export const WORD_CLOUD_FILLING_ANGLE = `${PREFIX}_WORD_CLOUD_FILLING_ANGLE`;

export const WORD_CLOUD_WEIGHT = `${PREFIX}_WORD_CLOUD_WEIGHT`;

export const WORDCLOUD_COLOR = `${PREFIX}_WORDCLOUD_COLOR`;

export const WORDCLOUD_DATA_TOTAL = `${PREFIX}_WORDCLOUD_DATA_TOTAL`;

export const WORD_CLOUD_TEXT = `${PREFIX}_WORD_CLOUD_TEXT`;

export const WORDCLOUD_SHAPE_DATA_TOTAL = `${PREFIX}_WORDCLOUD_SHAPE_DATA_TOTAL`;
//# sourceMappingURL=word-cloud.js.map